/*********************** User MockUp Data Starts ************************/

export const userColumnData = [
  { name: 'index', title: 'Sr#' },
  { name: 'name', title: 'Full Name' },
  { name: 'role', title: 'Role' },
  { name: 'phoneNumber', title: 'Contact Number' },
  { name: 'email', title: 'Contact Email' },
  { name: 'status', title: 'Status' },
  { name: 'isEmailVerified', title: 'Verified Email' },
  { name: 'createdAt', title: 'Created At' },
  { name: 'action', title: 'Action' }
];

export const userTableColumnExtensions = [
  { columnName: 'index', width: 100 },
  { columnName: 'name', width: 200 },
  { columnName: 'role', width: 100 },
  { columnName: 'phoneNumber', width: 150 },
  { columnName: 'email', width: 150 },
  { columnName: 'status', width: 150 },
  { columnName: 'isEmailVerified', width: 150 },
  { columnName: 'createdAt', width: 150 },
  { columnName: 'action', width: 80 }
];

export const userRowData = [
  {
    userName: 'Harry',
    userCode: 'Harry',
    address: 'WDC',
    contactEmail: 'lorem@gmail.com',
    contactNumber: '252565',
    status: true,
    uuid: 'adb86270fdba4bba8900e7371b089ade',
    id: 1
  },
  {
    userName: 'Harry',
    userCode: 'Harry',
    address: 'WDC',
    contactNumber: '252565',
    contactEmail: 'lorem@gmail.com',
    status: false,
    uuid: 'adb86270fdba4dda8900e7371b089ade',
    id: 2
  }
];

/*********************** User MockUp Data Ends ************************/

/*********************** Services MockUp Data Starts ************************/

export const allServicesColumnData = [
  { name: 'index', title: 'Sr#' },
  { name: 'serviceName', title: 'Service Name' },
  { name: 'description', title: 'Description' },
  // { name: 'salonName', title: 'Salon Name' },
  { name: 'price', title: 'Price' },
  { name: 'duration', title: 'Duration' },
  { name: 'createdAt', title: 'Created At' },
  { name: 'status', title: 'Status' },
  { name: 'action', title: 'Action' }
];

export const allServicesTableColumnExtensions = [
  { columnName: 'index', width: 100 },
  { columnName: 'serviceName', width: 150 },
  { columnName: 'description', width: 200 },
  // { columnName: 'salonName', width: 150 },
  { columnName: 'price', width: 100 },
  { columnName: 'duration', width: 100 },
  { columnName: 'createdAt', width: 150 },
  { columnName: 'status', width: 100 },
  { columnName: 'action', width: 100 }
];

export const allServicesData = [
  {
    userName: 'Harry',
    userCode: 'Harry',
    address: 'WDC',
    contactEmail: 'lorem@gmail.com',
    contactNumber: '252565',
    status: true,
    uuid: 'adb86270fdba4bba8900e7371b089ade',
    id: 1
  },
  {
    userName: 'Harry',
    userCode: 'Harry',
    address: 'WDC',
    contactNumber: '252565',
    contactEmail: 'lorem@gmail.com',
    status: false,
    uuid: 'adb86270fdba4dda8900e7371b089ade',
    id: 2
  }
];

/*********************** Services MockUp Data Ends ************************/

/*********************** Salons MockUp Data Starts ************************/

export const allSalonsColumnData = [
  { name: 'index', title: 'Sr#' },
  { name: 'salonName', title: 'Salon Name' },
  // { name: 'ownerName', title: 'Owner Name' },
  { name: 'address', title: 'Address' },
  { name: 'city', title: 'City' },
  { name: 'state', title: 'State' },
  { name: 'phoneNumber', title: 'Contact Number' },
  { name: 'zipCode', title: 'Zip Code' },
  { name: 'createdAt', title: 'Created At' }
];

export const allSalonsTableColumnExtensions = [
  { columnName: 'index', width: 100 },
  { columnName: 'salonName', width: 150 },
  // { columnName: 'ownerName', width: 200 },
  { columnName: 'address', width: 200 },
  { columnName: 'city', width: 100 },
  { columnName: 'state', width: 100 },
  { columnName: 'phoneNumber', width: 150 },
  { columnName: 'zipCode', width: 100 },
  { columnName: 'createdAt', width: 150 }
];

export const allSalonsData = [
  {
    userName: 'Harry',
    userCode: 'Harry',
    address: 'WDC',
    contactEmail: 'lorem@gmail.com',
    contactNumber: '252565',
    status: true,
    uuid: 'adb86270fdba4bba8900e7371b089ade',
    id: 1
  },
  {
    userName: 'Harry',
    userCode: 'Harry',
    address: 'WDC',
    contactNumber: '252565',
    contactEmail: 'lorem@gmail.com',
    status: false,
    uuid: 'adb86270fdba4dda8900e7371b089ade',
    id: 2
  }
];

/*********************** Salons MockUp Data Ends ************************/

/*********************** Salons MockUp Data Starts ************************/

export const allBookingsColumnData = [
  { name: 'index', title: 'Sr#' },
  { name: 'bookingUID', title: 'Booking ID' },
  { name: 'serviceName', title: 'Service Name' },
  { name: 'customerName', title: 'Customer Name' },
  { name: 'proName', title: 'Pro Name' },
  { name: 'address', title: 'Address' },
  { name: 'bookingDate', title: 'Booking Date' },
  { name: 'bookingDuration', title: 'Booking Duration' },
  { name: 'status', title: 'Status' },
  { name: 'action', title: 'Action' }
];

export const allBookingsTableColumnExtensions = [
  { columnName: 'index', width: 100 },
  { columnName: 'bookingUID', width: 150 },
  { columnName: 'serviceName', width: 180 },
  { columnName: 'customerName', width: 150 },
  { columnName: 'proName', width: 150 },
  { columnName: 'address', width: 200 },
  { columnName: 'bookingDate', width: 150 },
  { columnName: 'bookingDuration', width: 150 },
  { columnName: 'status', width: 150 }
];

export const allBookingsData = [
  {
    userName: 'Harry',
    userCode: 'Harry',
    address: 'WDC',
    contactEmail: 'lorem@gmail.com',
    contactNumber: '252565',
    status: true,
    uuid: 'adb86270fdba4bba8900e7371b089ade',
    id: 1
  },
  {
    userName: 'Harry',
    userCode: 'Harry',
    address: 'WDC',
    contactNumber: '252565',
    contactEmail: 'lorem@gmail.com',
    status: false,
    uuid: 'adb86270fdba4dda8900e7371b089ade',
    id: 2
  }
];

/*********************** Salons MockUp Data Ends ************************/
